import React, { Fragment, ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { Portal } from '../../shared/Portal/Portal.component';

import { ImpactCTA } from './ImpactCTA/ImpactCTA';
import { SocialShareButtons } from './SocialShareButtons/SocialShareButtons';

type IUseParams = {
    slug: string;
};

export function Article (): ReactElement {
    const { slug }: IUseParams = useParams();

    return (
        <Fragment>
            <Portal el="article-app__social-share">
                <SocialShareButtons />
            </Portal>
            <Portal el="article-app__impact-cta">
                <ImpactCTA title={slug} />
            </Portal>
        </Fragment>
    );
}
